module.exports = __webpack_public_path__ + "img/video-wip.14d70ce6.gif";